import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Flex } from '@h2/components/layout/flex'

const ActionsContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-end;
`
const MetricsContainer = styled.div`
  align-items: flex-start;
  flex: 1;
`
const ActionsRowActions = ({ children }) => {
  return <ActionsContainer>{children}</ActionsContainer>
}
const ActionsRowMetrics = () => {
  return <MetricsContainer></MetricsContainer>
}
const ActionsRow = ({ children }) => {
  return (
    <Flex gap="15px" direction="column" alignItems="flex-end" margin="15px">
      {children}
    </Flex>
  )
}

ActionsRowMetrics.slotName = 'ActionsRowMetrics'
ActionsRowMetrics.propTypes = {
  children: PropTypes.node.isRequired
}
ActionsRowActions.slotName = 'ActionsRowActions'
ActionsRowActions.propTypes = {
  children: PropTypes.node.isRequired
}

ActionsRow.Metrics = ActionsRowMetrics
ActionsRow.Actions = ActionsRowActions

export { ActionsRow }
